import { ReactElement } from 'react';
import { friendlyFormatIBAN, isValidIBAN } from 'ibantools';
import { TruncatedCopyableTextCell } from 'common/components/TruncatedCopyableCell/TruncatedCopyableCell';
import { truncateLabel } from 'common/utils/format.utils';

export const formatIfIBAN = (value: string | undefined): string =>
  value && isValidIBAN(value) ? friendlyFormatIBAN(value)! : value!;

export const RenderIBAN = ({ value, index }: { value: string, index: number }): ReactElement => (
  <TruncatedCopyableTextCell truncateFn={truncateLabel} indicator="*" length={8} rowIndex={index}>
    {formatIfIBAN(value)}
  </TruncatedCopyableTextCell>
);

export const RenderGUID = ({ value, index }: { value: string, index: number }): ReactElement => (
  <TruncatedCopyableTextCell truncateFn={truncateLabel} indicator="*" length={8} rowIndex={index}>
    {value}
  </TruncatedCopyableTextCell>
);

export const RenderAccountIBAN = (
  {
    record,
    index,
  }: {
    record: { wallet_account_guid?: string; guid?: string; iban?: string },
    index: number,
  }
): ReactElement => <RenderIBAN
  value={record.iban || record.guid! || record.wallet_account_guid || ''}
  index={index}
/>;
